exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alc-checkout__complete{margin-top:20px;max-width:440px;text-align:left}.alc-checkout__complete--centered{text-align:center}.alc-checkout__checkout{min-height:500px}\n", ""]);

// exports
exports.locals = {
	"alc-checkout__complete": "alc-checkout__complete",
	"alc-checkout__complete--centered": "alc-checkout__complete--centered",
	"alc-checkout__checkout": "alc-checkout__checkout"
};